import HTTP from "../../http";

const PAYMENTS_ENDPOINT = "/payments";
const PAYMENTS_STRIPE_ID_ENPOINT = "/stripe_id/";

export async function getStripeIdForStore(storeId) {
  return await HTTP.get(
    PAYMENTS_ENDPOINT + PAYMENTS_STRIPE_ID_ENPOINT + storeId
  );
}
